import {
  AD_CREATED,
} from 'actions/editable-ad';
import {
  GUIDELINE_PDF_CLICKED,
  LANDING_VIDEO_PLAYED,
  LOG_USER_ACTION,
  GA_PARTNER_ID_RECEIVED,
} from 'actions/analytics';

import { LOCATION_CHANGE } from 'react-router-redux/lib/reducer';

export default function googleAnalytics(ga) {
  return () => next => action => {
    switch (action.type) {
      case LOCATION_CHANGE:
        ga.pageview(action.payload.pathname);
        break;
      case LOG_USER_ACTION: {
        const { category, label, params } = action.payload;
        ga.event({ category, action: label, label: params && JSON.stringify(params) });
        break;
      }
      // TODO: If we opt to store certain build_ad fields as dimensions:
      // case UPDATE_FIELDS: {
      //   if (fieldsToStore.includes(fieldName)) {
      //     ga('set', fieldName, value);
      //   }
      //   break;
      // }
      case AD_CREATED:
        ga.event({
          category: 'Ad Creation',
          action: 'Created',
          label: action.name,
        });
        // TODO: If we opt to store certain build_ad fields as dimensions:
        // clear build_ad dimensions
        // ga('set', fieldsToStore.reduce(result, fieldName => ({...result, [fieldName]: null}), {}));
        break;
      case GUIDELINE_PDF_CLICKED:
        ga.event({
          category: 'File',
          action: 'download',
          label: 'Creative Audio Guidelines',
        });
        break;
      case LANDING_VIDEO_PLAYED:
        ga.event({
          category: 'Video',
          action: 'play',
          label: 'Audio Impact Video',
        });
        break;
      case GA_PARTNER_ID_RECEIVED:
        ga.set({
          userId: action.payload.partnerId,
          dimension1: action.payload.partnerId,
        });
        break;
      default:
    }

    return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/middleware/googleAnalytics.js